import {NgModule} from "@angular/core";
import {BrowserModule} from "@angular/platform-browser";
import {BootstrapModalModule} from "../bootstrap-modal/bootstrap-modal.module";
import {FormsModule, ReactiveFormsModule} from "@angular/forms";
import {HttpHelpersModule} from "../http/http-helpers.module";
import {AppAlertService} from "./app-alert.service";
import {AppSettingsModule} from "../app-settings/app-settings.module";
import {AppAlertComponent} from "./app-alert.component";
import {AppAlertContainerComponent} from "./app-alert-container.component";
import {AppAlertManagerComponent} from "./app-alert-manager.component";
import {AppAlertEditDialogComponent} from "./app-alert-edit-dialog.component";
import {GraphqlCoreModule} from "../graphql/graphql-core.module";

@NgModule({
  providers: [
    AppAlertService,
  ],
  imports: [
    BrowserModule,
    BootstrapModalModule,
    FormsModule,
    ReactiveFormsModule,
    HttpHelpersModule,
    AppSettingsModule,
    GraphqlCoreModule,
  ],
  declarations: [
    AppAlertComponent,
    AppAlertContainerComponent,
    AppAlertManagerComponent,
    AppAlertEditDialogComponent,
  ],
  exports: [
    AppAlertComponent,
    AppAlertContainerComponent,
    AppAlertManagerComponent,
    AppAlertEditDialogComponent,
  ],
  entryComponents: [
    AppAlertEditDialogComponent,
  ],
})

export class AppAlertModule {
}
